module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_inomemado@2x-53e7d12718ebcf2027d3514aa9ce8769.webp";